import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { AngularModule } from '../../../../../../modules/angular.module';
import { ZorroModule } from '../../../../../../modules/zorro.module';
import { StrideProgressItem, StrideStudentReportData, RubricLevel } from '@mira-avant/mtlibs';

@Component({
	selector: 'app-skill-progress',
	standalone: true,
	imports: [AngularModule, ZorroModule],
	templateUrl: './skill-progress.component.html',
	styleUrl: './skill-progress.component.scss',
})
export class SkillProgressComponent {
	@Input('report') public report: StrideStudentReportData | undefined;
	@Input('selectedSkill') public selectedSkill: string | undefined;
	@Input('selectedRubricLevel') public selectedRubricLevel: RubricLevel | undefined;
	@Output('onSelect') public onSelectEmitter: EventEmitter<StrideProgressItem> =
		new EventEmitter();

	public selectedProgress: StrideProgressItem[] = [];
	public selectedItem: StrideProgressItem | undefined;

	ngOnChanges(changes: SimpleChanges): void {
		if (this.report && this.selectedSkill) {
			this.selectedProgress = this.report.progress[this.selectedSkill] || [];

			//If the skill changed, unselect the current item
			if (
				changes['selectedSkill']?.currentValue !== changes['selectedSkill']?.previousValue
			) {
				//Remove currently selected progress item
				this.toggleSelectedItem(undefined);

				//Automatically select the last progress item if one exists
				if (this.selectedProgress.length > 0) {
					this.toggleSelectedItem(
						this.selectedProgress[this.selectedProgress.length - 1]
					);
				}
			}
		}
	}

	public toggleSelectedItem(item?: StrideProgressItem | undefined): void {
		if (this.selectedItem === item) {
			this.selectedItem = undefined;
		} else {
			this.selectedItem = item;
		}

		this.onSelectEmitter.emit(this.selectedItem);
	}
}
